<template>
  <Layout>
    <div class="shopping-cart">
      <h1 class="main-title">購物車</h1>
      <h2 class="sub-title">SHOPPING CART</h2>
      
      <!-- 進度條 -->
      <div class="checkout-progress">
        <div class="custom-progress-bar">
        <div class="progress-step">
          <div class="step-number">1</div>
          <div class="step-label">購物車</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step active">
          <div class="step-number">2</div>
          <div class="step-label">結帳</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step">
          <div class="step-number">3</div>
          <div class="step-label">完成</div>
          </div>
        </div>
      </div>

      <div class="cart-content">
        <!-- 左側：表單區塊 -->
        <div class="checkout-form">
          <!-- 運送方式卡片 -->
          <div class="form-card shipping-method-card">
            <h3>運送方式</h3>
            <div class="shipping-method-options">
              <div v-if="isShippingMethodAvailable('family-mart')" class="shipping-method-option">
                <input type="radio" id="family-mart" name="shipping-method" value="family-mart" v-model="shippingMethod">
                <label for="family-mart">
                  <div class="method-header">
                    <img :src="require('@/assets/img/family-mart.svg')" alt="全家便利商店" class="method-icon">
                    <span class="method-name">全家便利商店</span>
                  </div>
                  <span class="method-desc">預計 2-3 個工作天送達</span>
                </label>
              </div>
              <div v-if="isShippingMethodAvailable('seven-eleven')" class="shipping-method-option">
                <input type="radio" id="seven-eleven" name="shipping-method" value="seven-eleven" v-model="shippingMethod">
                <label for="seven-eleven">
                  <div class="method-header">
                    <img :src="require('@/assets/img/seven-eleven.svg')" alt="7-ELEVEN" class="method-icon">
                    <span class="method-name">7-ELEVEN</span>
                  </div>
                  <span class="method-desc">預計 2-3 個工作天送達</span>
                </label>
              </div>
              <div v-if="isShippingMethodAvailable('home-delivery')" class="shipping-method-option">
                <input type="radio" id="home-delivery" name="shipping-method" value="home-delivery" v-model="shippingMethod">
                <label for="home-delivery">
                  <div class="method-header">
                    <img :src="require('@/assets/img/home-delivery.svg')" alt="宅配到府" class="method-icon">
                    <span class="method-name">宅配到府</span>
                  </div>
                  <span class="method-desc">預計 1-2 個工作天送達</span>
                </label>
              </div>
              
              <!-- 如果沒有可用的運送方式 -->
              <div v-if="!hasAvailableShippingMethods" class="no-shipping-methods">
                <p>目前沒有可用的運送方式，請聯繫客服。</p>
              </div>
            </div>
          </div>

          <!-- 會員登入選項卡片 -->
          <div class="form-card login-option-card">
            <h3>會員登入 (可選)</h3>
            <div class="login-options">
              <!-- 訪客結帳選項 - 僅在未登入時顯示 -->
              <div class="login-option" v-if="!isAuthenticated">
                <input type="radio" id="guest-checkout" name="checkout-type" value="guest" v-model="checkoutType">
                <label for="guest-checkout">
                  <span class="option-label">訪客結帳</span>
                  <span class="option-desc">無需註冊，直接結帳</span>
                </label>
              </div>
              
              <!-- 會員結帳選項 - 僅在未登入時顯示 -->
              <div class="login-option" v-if="!isAuthenticated">
                <input type="radio" id="member-checkout" name="checkout-type" value="member" v-model="checkoutType">
                <label for="member-checkout">
                  <span class="option-label">會員結帳</span>
                  <span class="option-desc">登入會員享受更多優惠</span>
                </label>
              </div>
              
              <!-- 註冊新會員選項 - 僅在未登入時顯示 -->
              <div class="login-option" v-if="!isAuthenticated">
                <input type="radio" id="register-checkout" name="checkout-type" value="register" v-model="checkoutType">
                <label for="register-checkout">
                  <span class="option-label">註冊新會員</span>
                  <span class="option-desc">立即註冊，享受會員優惠</span>
                </label>
              </div>
              
              <!-- 已登入會員顯示 - 顯示當前會員資訊 -->
              <div v-if="isAuthenticated" class="member-info">
                <div class="member-info-header">
                  <i class="fas fa-user-check"></i>
                  <span class="member-status">已登入會員</span>
                </div>
                <div class="member-details">
                  <p class="member-name">{{ customer?.name || '會員' }}</p>
                  <p class="member-email">{{ customer?.email }}</p>
                </div>
                <button @click="handleLogout" class="logout-btn">登出</button>
              </div>
            </div>
            
            <!-- 會員登入表單 -->
            <div v-if="checkoutType === 'member' && !isAuthenticated" class="member-login-form">
              <div class="form-group">
                <label for="login-email">電子郵件</label>
                <input type="email" id="login-email" v-model="loginForm.email" placeholder="請輸入電子郵件">
              </div>
              <div class="form-group">
                <label for="login-password">密碼</label>
                <input type="password" id="login-password" v-model="loginForm.password" placeholder="請輸入密碼">
              </div>
              <button @click="handleLogin" class="login-btn">登入</button>
            </div>
            
            <!-- 會員註冊表單 -->
            <div v-if="checkoutType === 'register' && !isAuthenticated" class="member-register-form">
              <div class="form-row">
                <div class="form-group">
                  <label for="register-lastName">姓</label>
                  <input type="text" id="register-lastName" v-model="registerForm.lastName" placeholder="請輸入姓">
                </div>
                <div class="form-group">
                  <label for="register-firstName">名</label>
                  <input type="text" id="register-firstName" v-model="registerForm.firstName" placeholder="請輸入名">
                </div>
              </div>
              <div class="form-group">
                <label for="register-phone">手機號碼</label>
                <input type="tel" id="register-phone" v-model="registerForm.phone" placeholder="請輸入手機號碼">
              </div>
              <div class="form-group">
                <label for="register-email">電子郵件</label>
                <input type="email" id="register-email" v-model="registerForm.email" placeholder="請輸入電子郵件">
              </div>
              <div class="form-group">
                <label for="register-password">密碼</label>
                <input type="password" id="register-password" v-model="registerForm.password" placeholder="請輸入密碼">
              </div>
              <button @click="handleRegister" class="register-btn">註冊</button>
            </div>
          </div>

          <!-- 訂購人資訊卡片 -->
          <div class="form-card order-info-card">
            <h3>訂購人資訊</h3>
            <div class="order-info-fields">
              <div class="form-row">
                <div class="form-group">
                  <label for="lastName">姓</label>
                  <input type="text" id="lastName" v-model="orderInfo.lastName" placeholder="請輸入姓">
                </div>
                <div class="form-group">
                  <label for="firstName">名</label>
                  <input type="text" id="firstName" v-model="orderInfo.firstName" placeholder="請輸入名">
                </div>
              </div>
              <div class="form-group">
                <label for="phone">手機號碼</label>
                <input type="tel" id="phone" v-model="orderInfo.phone" placeholder="請輸入手機號碼">
              </div>
              <div class="form-group">
                <label for="email">電子郵件</label>
                <input type="email" id="email" v-model="orderInfo.email" placeholder="請輸入電子郵件">
              </div>
            </div>
          </div>

          <!-- 收件地址卡片 -->
          <div class="form-card shipping-address-card">
            <h3>收件地址</h3>
            <div class="shipping-address-fields">
              <div class="form-group">
                <label for="address">地址</label>
                <input type="text" id="address" v-model="orderInfo.address" placeholder="請輸入地址">
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="city">城市</label>
                  <input type="text" id="city" v-model="orderInfo.city" placeholder="請輸入城市">
                </div>
                <div class="form-group">
                  <label for="postalCode">郵遞區號</label>
                  <input type="text" id="postalCode" v-model="orderInfo.postalCode" placeholder="請輸入郵遞區號">
                </div>
              </div>
            </div>
          </div>

          <!-- 付款方式卡片 -->
          <div class="form-card payment-method-card">
            <h3>付款方式</h3>
            <div class="payment-method-options">
              <div v-if="isPaymentMethodAvailable('convenience-store')" class="payment-method-option">
                <input type="radio" id="convenience-store" name="payment-method" value="convenience-store" v-model="paymentMethod">
                <label for="convenience-store">
                  <div class="method-header">
                    <img :src="require('@/assets/img/convenience-store.jpg')" alt="便利商店" class="method-icon">
                    <span class="method-name">便利商店</span>
                  </div>
                  <span class="method-desc">使用便利商店付款</span>
                </label>
              </div>
            </div>
            <div class="payment-method-options">
              <!-- LiCoin 付款方式 -->
              <div v-if="isPaymentMethodAvailable('licoin')" class="payment-method-option">
                <input type="radio" id="licoin" name="payment-method" value="licoin" v-model="paymentMethod">
                <label for="licoin">
                  <div class="method-header">
                    <img :src="require('@/assets/img/licoin.svg')" alt="LiCoin" class="method-icon">
                    <span class="method-name">LiCoin</span>
                  </div>
                  <span class="method-desc">使用 LiCoin 快速付款</span>
                </label>
              </div>
              
              <!-- Tappay 信用卡付款方式 -->
              <div v-if="isPaymentMethodAvailable('tappay')" class="payment-method-option">
                <input type="radio" id="tappay" name="payment-method" value="tappay" v-model="paymentMethod">
                <label for="tappay">
                  <div class="method-header">
                    <div class="payment-icons">
                      <img :src="require('@/assets/img/visa.svg')" alt="Visa" class="method-icon">
                      <img :src="require('@/assets/img/master-card.svg')" alt="MasterCard" class="method-icon">
                      <img :src="require('@/assets/img/jcb.svg')" alt="JCB" class="method-icon">
                      <img :src="require('@/assets/img/unionpay.svg')" alt="UnionPay" class="method-icon">
                    </div>
                    <span class="method-name">信用卡 (Tappay)</span>
                  </div>
                  <span class="method-desc">支援 Visa、MasterCard、JCB、銀聯</span>
                </label>
              </div>
              
              <!-- Apple Pay 付款方式 -->
              <div v-if="isPaymentMethodAvailable('apple-pay')" class="payment-method-option">
                <input type="radio" id="apple-pay" name="payment-method" value="apple-pay" v-model="paymentMethod">
                <label for="apple-pay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/apple-pay.svg')" alt="Apple Pay" class="method-icon">
                    <span class="method-name">Apple Pay</span>
                  </div>
                  <span class="method-desc">使用 Apple Pay 快速付款</span>
                </label>
              </div>
              
              <!-- 街口支付付款方式 -->
              <div v-if="isPaymentMethodAvailable('jkopay')" class="payment-method-option">
                <input type="radio" id="jkopay" name="payment-method" value="jkopay" v-model="paymentMethod">
                <label for="jkopay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/jkopay.svg')" alt="街口支付" class="method-icon">
                    <span class="method-name">街口支付</span>
                  </div>
                  <span class="method-desc">使用街口支付快速付款</span>
                </label>
              </div>
              
              <!-- LINE Pay 付款方式 -->
              <div v-if="isPaymentMethodAvailable('line-pay')" class="payment-method-option">
                <input type="radio" id="line-pay" name="payment-method" value="line-pay" v-model="paymentMethod">
                <label for="line-pay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/line-pay.svg')" alt="LINE Pay" class="method-icon">
                    <span class="method-name">LINE Pay</span>
                  </div>
                  <span class="method-desc">使用 LINE Pay 快速付款</span>
                </label>
              </div>
              
              <!-- 如果沒有可用的付款方式 -->
              <div v-if="!hasAvailablePaymentMethods" class="no-payment-methods">
                <p>目前沒有可用的付款方式，請聯繫客服。</p>
              </div>
            </div>
          </div>

          <!-- 發票資訊卡片 -->
          <div class="form-card invoice-info-card">
            <h3>發票資訊</h3>
            <div class="invoice-info-fields">
              <div class="form-group">
                <label for="invoice-type">發票類型</label>
                <select id="invoice-type" v-model="invoiceInfo.type">
                  <option value="personal">個人</option>
                  <option value="company">公司</option>
                </select>
              </div>
              <div v-if="invoiceInfo.type === 'company'" class="form-group">
                <label for="company-name">公司名稱</label>
                <input type="text" id="company-name" v-model="invoiceInfo.companyName" placeholder="請輸入公司名稱">
              </div>
              <div v-if="invoiceInfo.type === 'company'" class="form-group">
                <label for="tax-id">統一編號</label>
                <input type="text" id="tax-id" v-model="invoiceInfo.taxId" placeholder="請輸入統一編號">
              </div>
            </div>
          </div>

          <!-- 購物須知卡片 -->
          <div class="form-card shopping-notice-card">
            <h3>購物須知</h3>
            <div class="shopping-notice-content">
              <p>1. 商品將於付款完成後 1-2 個工作天內出貨</p>
              <p>2. 運送範圍僅限台灣本島地區</p>
              <p>3. 如需退換貨，請於收到商品後 7 天內提出申請</p>
              <p>4. 如有任何問題，歡迎聯繫客服中心</p>
            </div>
          </div>
        </div>
        <!-- 右側：優惠券和結帳明細 -->
        <div class="checkout-summary">
          <!-- 優惠券 -->
          <div class="coupon-section">
            <h3>優惠券</h3>
            <div class="coupon-input">
              <input 
                type="text" 
                v-model="discountCode" 
                placeholder="請輸入優惠碼"
                @keyup.enter="applyDiscount"
              >
              <button @click="applyDiscount" class="apply-btn">套用</button>
            </div>
          </div>

          <!-- 結帳明細 -->
          <div class="order-summary">
            <h3>結帳明細</h3>
            <div class="summary-details">
              <div class="summary-row">
                <span>小計</span>
                <span>$NTD {{ subtotal }}</span>
              </div>
              <div v-if="discount" class="summary-row discount">
                <span>折扣</span>
                <span>-$NTD {{ discount }}</span>
              </div>
              <div class="summary-row">
                <span>運費</span>
                <span>$NTD {{ shipping }}</span>
              </div>
              <div class="summary-row">
                <span>稅金</span>
                <span>$NTD {{ tax }}</span>
              </div>
              <div class="summary-row total">
                <span>總計</span>
                <span>$NTD {{ total }}</span>
              </div>
              <div v-if="paymentMethod === 'licoin'" class="summary-row licoin-total">
                <span>LiCoin 支付</span>
                <span>{{ licoinAmount }} LiCoin</span>
              </div>
            </div>
          </div>

          <!-- 前往結帳按鈕 -->
          <button @click="proceedToCheckout" class="checkout-btn">
            確認結帳
          </button>

          <!-- 支援付款方式 -->
          <div class="payment-methods">
            <h3>支援付款方式</h3>
            <div class="payment-icons">
              <img v-for="(icon, index) in paymentIcons" 
                    :key="index" 
                    :src="icon" 
                    :alt="'payment-' + index">
            </div>
          </div>

          <!-- 支援運送方式 -->
          <div class="shipping-methods">
            <h3>支援運送方式</h3>
            <div class="shipping-icons">
              <img v-for="(icon, index) in shippingIcons" 
                    :key="index" 
                    :src="icon" 
                    :alt="'shipping-' + index">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Layout from '@/layouts/Layout.vue'

export default {
  name: 'Cart',
  components: {
    Layout
  },
  data() {
    return {
      discountCode: '',
      discount: 0,
      checkoutType: 'guest', // 默认选择访客结账
      shippingMethod: 'home-delivery',
      paymentMethod: 'tappay',
      orderInfo: {
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        address: '',
        city: '',
        postalCode: ''
      },
      invoiceInfo: {
        type: 'personal',
        companyName: '',
        taxId: ''
      },
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState(['cartItems', 'storeInfo']),
    ...mapGetters(['isAuthenticated', 'currentCustomer']),
    customer() {
      return this.currentCustomer
    },
    subtotal() {
      return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    },
    shipping() {
      return 0
    },
    tax() {
      // return (this.subtotal - this.discount) * 0.1
      return 0
    },
    total() {
      return this.subtotal - this.discount + this.shipping + this.tax
    },
    licoinAmount() {
      return this.total / 100 // 1 LiCoin = 100 NTD
    },
    availableShippingMethods() {
      return this.storeInfo?.available_shipping_methods || ['family-mart', 'seven-eleven', 'home-delivery']
    },
    hasAvailableShippingMethods() {
      return this.availableShippingMethods && this.availableShippingMethods.length > 0
    },
    availablePaymentMethods() {
      return this.storeInfo?.available_payment_methods || ['licoin', 'tappay', 'apple-pay', 'jkopay', 'line-pay']
    },
    hasAvailablePaymentMethods() {
      return this.availablePaymentMethods && this.availablePaymentMethods.length > 0
    },
    paymentIcons() {
      const icons = []
      
      // Payment method to icon mapping
      const paymentMethodIcons = {
        'tappay': [
          require('@/assets/img/visa.svg'),
          require('@/assets/img/master-card.svg'),
          require('@/assets/img/unionpay.svg')
        ],
        'apple-pay': [
          require('@/assets/img/apple-pay.svg')
        ],
        'jkopay': [
          require('@/assets/img/jkopay.svg')
        ],
        'line-pay': [
          require('@/assets/img/line-pay.svg')
        ],
        'licoin': [
          require('@/assets/img/licoin.svg')
        ],
        'convenience-store': [
          require('@/assets/img/convenience-store.jpg')
        ]
      }
      
      // Add icons for each available payment method
      this.availablePaymentMethods.forEach(method => {
        if (paymentMethodIcons[method]) {
          icons.push(...paymentMethodIcons[method])
        }
      })
      
      return icons
    },
    shippingIcons() {
      const icons = []
      
      // Shipping method to icon mapping
      const shippingMethodIcons = {
        'family-mart': [
          require('@/assets/img/family-mart.svg')
        ],
        'seven-eleven': [
          require('@/assets/img/seven-eleven.svg')
        ],
        'home-delivery': [
          require('@/assets/img/home-delivery.svg')
        ]
      }
      
      // Add icons for each available shipping method
      this.availableShippingMethods.forEach(method => {
        if (shippingMethodIcons[method]) {
          icons.push(...shippingMethodIcons[method])
        }
      })
      
      return icons
    }
  },
  methods: {
    ...mapMutations([
      'setOrderInfo',
      'setInvoiceInfo',
      'setShippingMethod',
      'setPaymentMethod'
    ]),
    ...mapActions(['updateCartItemQuantity', 'removeFromCart', 'fetchStoreInfo']),
    getImageUrl(image) {
      return `/img/${image}`
    },
    updateQuantity(item, newQuantity) {
      if (newQuantity < 1) {
        newQuantity = 1
      }
      this.updateCartItemQuantity({ item, quantity: newQuantity })
    },
    proceedToCheckout() {
      // 根据结账类型进行不同的验证
      if (this.checkoutType === 'guest') {
        // 访客结账：验证基本信息
        if (this.orderInfo.lastName === '' || this.orderInfo.firstName === '' || this.orderInfo.phone === '') {
          alert('請填寫完整訂購人資訊')
          return
        }
      } else if (this.checkoutType === 'member' && !this.isAuthenticated) {
        // 会员结账但未登录
        alert('請先登入會員')
        return
      } else if (this.checkoutType === 'register' && !this.isAuthenticated) {
        // 注册结账但未完成注册
        if (this.registerForm.lastName === '' || this.registerForm.firstName === '' || this.registerForm.phone === '' || this.registerForm.email === '' || this.registerForm.password === '') {
          alert('請填寫完整註冊資訊')
          return
        }
      }

      // 验证运货方式
      if (this.shippingMethod === '') {
        alert('請選擇運送方式')
        return
      }
      if (!this.isShippingMethodAvailable(this.shippingMethod)) {
        alert('所選擇的運送方式不可用，請重新選擇')
        return
      }

      // 验证付款方式
      if (this.paymentMethod === '') {
        alert('請選擇付款方式')
        return
      }
      if (!this.isPaymentMethodAvailable(this.paymentMethod)) {
        alert('所選擇的付款方式不可用，請重新選擇')
        return
      }

      // 验证发票信息
      if (this.invoiceInfo.type === '') {
        alert('請選擇發票類型')
        return
      }
      if (this.invoiceInfo.type === 'company' && (this.invoiceInfo.companyName === '' || this.invoiceInfo.taxId === '')) {
        alert('請填寫完整發票資訊')
        return
      }

      // 保存订单信息到 store
      this.setOrderInfo(this.orderInfo)
      this.setInvoiceInfo(this.invoiceInfo)
      this.setShippingMethod(this.shippingMethod)
      this.setPaymentMethod(this.paymentMethod)

      // 根据结账类型处理
      if (this.checkoutType === 'guest') {
        this.handleGuestCheckout()
      } else if (this.checkoutType === 'member' || this.checkoutType === 'register') {
        // 会员结账：根据付款方式处理
        if (this.paymentMethod === 'licoin') {
          this.handleLiCoinPayment()
        } else if (this.paymentMethod === 'tappay') {
          this.handleTappayPayment()
        } else {
          this.$router.push('/checkout/done')
        }
      }
    },
    async handleGuestCheckout() {
      try {
        // 准备购物车数据
        const cartItemsData = this.cartItems.map(item => ({
          product_id: item.product_id,
          product_variation_id: item.product_variation_id,
          quantity: item.quantity,
          price: item.price
        }))

        // 准备订单数据
        const orderData = {
          cart_items: cartItemsData,
          shipping_address: `${this.orderInfo.address}, ${this.orderInfo.city} ${this.orderInfo.postalCode}`,
          payment_method: this.paymentMethod,
          shipping_method: this.shippingMethod,
          order_info: this.orderInfo
        }

        // 调用访客结账 API
        const response = await this.$http.post('/api/v1/checkout/guest', orderData)

        const result = await response.json()
        console.log('访客订单创建成功:', result)
        
        // 清空购物车
        this.$store.commit('clearCart')
        
        // 根据付款方式跳转
        if (this.paymentMethod === 'tappay') {
          // 传递订单信息到支付页面
          this.$router.push({
            path: '/checkout/tappay-payment',
            query: {
              order_id: result.order.id,
              guest: 'true'
            }
          })
        } else {
          this.$router.push('/checkout/done')
        }
      } catch (error) {
        console.error('访客结账失败:', error)
        alert('結帳失敗，請稍後再試')
      }
    },
    async handleLiCoinPayment() {
      try {
        const hasEnoughBalance = await this.$store.dispatch('checkLiCoinBalance', this.licoinAmount)
        if (hasEnoughBalance) {
          await this.$store.dispatch('transferLiCoin', {
            amount: this.licoinAmount,
            orderInfo: {
              ...this.orderInfo,
              shippingMethod: this.shippingMethod,
              paymentMethod: this.paymentMethod,
              invoiceInfo: this.invoiceInfo
            }
          })
      this.$router.push('/checkout/done')
        } else {
          alert('LiCoin 餘額不足，請先購買 LiCoin')
          this.$router.push('/licoin')
        }
      } catch (error) {
        console.error('LiCoin 付款失敗:', error)
        alert('付款失敗，請稍後再試')
      }
    },
    handleTappayPayment() {
      // 跳轉到 Tappay 付款頁面
      this.$router.push('/checkout/tappay-payment')
    },
    async handleLogin() {
      try {
        const response = await this.$http.post('/api/v1/customers/sign_in', {
          api_v1_customer: {
            email: this.loginForm.email,
            password: this.loginForm.password
          }
        })

        const result = await response.json()
        // 保存登录状态
        this.$store.commit('SET_TOKEN', result.token)
        this.$store.commit('SET_CUSTOMER', result.data)
        
        // 切换到会员结账模式
        this.checkoutType = 'member'
        this.$store.dispatch('fetchCartItems')
        
        alert('登入成功！已切換到會員結帳模式')
      } catch (error) {
        console.error('登入失败:', error)
        alert('登入失敗，請稍後再試')
      }
    },
    async handleRegister() {
      try {
        const response = await this.$http.post('/api/v1/customers', {
          api_v1_customer: {
            name: `${this.registerForm.firstName} ${this.registerForm.lastName}`,
            phone: this.registerForm.phone,
            email: this.registerForm.email,
            password: this.registerForm.password,
            password_confirmation: this.registerForm.password
          }
        })

        const result = await response.json()
        // 保存登录状态
        this.$store.commit('SET_TOKEN', result.token)
        this.$store.commit('SET_CUSTOMER', result.data)
        
        // 切换到会员结账模式
        this.checkoutType = 'member'
        this.$store.dispatch('fetchCartItems')
        
        alert('註冊成功！已自動登入並切換到會員結帳模式')
      } catch (error) {
        console.error('注册失败:', error)
        alert('註冊失敗，請稍後再試')
      }
    },
    handleLogout() {
      // 清除會員登入狀態
      this.$store.commit('SET_TOKEN', null)
      this.$store.commit('SET_CUSTOMER', null)
      localStorage.removeItem('token')
      localStorage.removeItem('customer')
      
      // 切換回訪客結帳模式
      this.checkoutType = 'guest'
      
      // 清空購物車
      this.$store.commit('clearCart')
      
      alert('已登出會員')
    },
    applyDiscount() {
      if (this.discountCode === 'SAVE20') {
        this.discount = this.subtotal * 0.2
      } else if (this.discountCode === 'SAVE10') {
        this.discount = this.subtotal * 0.1
      } else {
        this.discount = 0
        alert('無效的優惠碼')
      }
    },
    isShippingMethodAvailable(methodName) {
      return this.availableShippingMethods && this.availableShippingMethods.includes(methodName)
    },
    isPaymentMethodAvailable(methodName) {
      return this.availablePaymentMethods && this.availablePaymentMethods.includes(methodName)
    },
    setDefaultShippingMethod() {
      // 如果當前選擇的運送方式不可用，則選擇第一個可用的運送方式
      if (!this.isShippingMethodAvailable(this.shippingMethod) && this.availableShippingMethods.length > 0) {
        this.shippingMethod = this.availableShippingMethods[0]
      }
    },
    setDefaultPaymentMethod() {
      // 如果當前選擇的付款方式不可用，則選擇第一個可用的付款方式
      if (!this.isPaymentMethodAvailable(this.paymentMethod) && this.availablePaymentMethods.length > 0) {
        this.paymentMethod = this.availablePaymentMethods[0]
      }
    }
  },
  async created() {
    // 獲取 store 資訊
    await this.fetchStoreInfo()
    
    // 設定預設運送方式
    this.setDefaultShippingMethod()
    // 設定預設付款方式
    this.setDefaultPaymentMethod()
  }
}
</script>

<style scoped>
.shopping-cart {
  max-width: 1200px;
  margin: 80px auto 2rem auto;
  padding: 0 2rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.checkout-progress {
  margin-bottom: 2rem;
}

.custom-progress-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.progress-step.active .step-number {
  background-color: #F99393;
  color: white;
}

.step-label {
  font-size: 0.875rem;
  color: #6c757d;
}

.progress-step.active .step-label {
  color: #F99393;
  font-weight: bold;
}

.progress-line {
  flex: 1;
  height: 2px;
  background-color: #e9ecef;
  margin: 0 1rem;
  position: relative;
  top: -15px;
}

.progress-line.active {
  background-color: #F99393;
}

.cart-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cart-item {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 1rem;
  padding: 2rem;
  background-color: #FBFBFB;
  border-radius: 8px;
}

.item-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.item-name {
  font-size: 1.1rem;
  font-weight: 500;
}

.item-variants {
  display: flex;
  gap: 1rem;
}

.variant {
  color: #666;
  font-size: 0.9rem;
}

.item-price {
  font-weight: 500;
}

.item-quantity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: none;
  cursor: pointer;
}

.quantity {
  min-width: 30px;
  text-align: center;
}

.remove-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
}

.checkout-summary {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.coupon-section,
.order-summary,
.payment-methods {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
}

.coupon-input {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.coupon-input input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.apply-btn {
  padding: 0.5rem 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  color: #666;
}

.summary-row.discount {
  color: #4CAF50;
}

.summary-row.total {
  font-weight: bold;
  color: #000;
  font-size: 1.2rem;
  border-top: 1px solid #ddd;
  padding-top: 1rem;
  margin-top: 1rem;
}

.checkout-btn {
  width: 100%;
  padding: 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.checkout-btn:hover {
  color: white;
}

.payment-icons {
  display: flex;
  gap: 1rem;
  font-size: 2rem;
  color: #666;
}

.shipping-methods {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
}

.shipping-methods h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.shipping-icons {
  display: flex;
  gap: 1rem;
  font-size: 2rem;
  color: #666;
}

.shipping-icons img,
.payment-icons img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.checkout-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #F99393;
}

/* 会员登录选项样式 */
.login-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.login-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.login-option:hover {
  border-color: #F99393;
  background-color: #fefefe;
}

.login-option input[type="radio"] {
  margin: 0;
}

.login-option label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  cursor: pointer;
  flex: 1;
}

.option-label {
  font-weight: 600;
  color: #333;
}

.option-desc {
  font-size: 0.875rem;
  color: #666;
}

.member-login-form,
.member-register-form {
  margin-top: 1.5rem;
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.login-btn,
.register-btn {
  width: 100%;
  padding: 0.75rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-btn:hover,
.register-btn:hover {
  background-color: #e88585;
}

/* 已登入會員資訊樣式 */
.member-info {
  padding: 1.5rem;
  background-color: #f0f8ff;
  border: 1px solid #4a90e2;
  border-radius: 8px;
  text-align: center;
}

.member-info-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: #4a90e2;
  font-weight: 600;
}

.member-info-header i {
  font-size: 1.2rem;
}

.member-details {
  margin-bottom: 1.5rem;
}

.member-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.member-email {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.logout-btn {
  padding: 0.5rem 1rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background-color: #c82333;
}

.shipping-method-options,
.payment-method-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.shipping-method-option,
.payment-method-option {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment-method-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.shipping-method-option:hover,
.payment-method-option:hover {
  border-color: #F99393;
  background-color: #FFF5F5;
}

.shipping-method-option input[type="radio"],
.payment-method-option input[type="radio"] {
  margin-top: 0.4rem;
}

.shipping-method-option input[type="radio"]:checked + label,
.payment-method-option input[type="radio"]:checked + label {
  color: #F99393;
}

.shipping-method-option input[type="radio"]:checked + label .method-header,
.payment-method-option input[type="radio"]:checked + label .method-header {
  color: #F99393;
}

.method-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.payment-icons .method-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.method-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.method-name {
  font-weight: 600;
  color: #333;
}

.method-desc {
  font-size: 0.9rem;
  color: #666;
}

.shopping-notice-content {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
}

.shopping-notice-content p {
  margin-bottom: 0.5rem;
}

.summary-row.licoin-total {
  color: #F99393;
  font-weight: bold;
  border-top: 1px solid #ddd;
  padding-top: 1rem;
  margin-top: 0.5rem;
}

.no-shipping-methods {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #6c757d;
}

.no-shipping-methods p {
  margin: 0;
  font-size: 1rem;
}

.no-payment-methods {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #6c757d;
}

.no-payment-methods p {
  margin: 0;
  font-size: 1rem;
}
</style> 
